module.exports = __webpack_public_path__ + "static/media/mario-64.c8264d71.mp3";